module.exports = __webpack_public_path__ + "static/media/cangrejo_tex.6211c3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/cangrejo/cangrejo_tex.png
// module id = 140
// module chunks = 0